/** Parse complete SSE records, retaining their durable cursor across chunk boundaries. */
export async function* readSseEvents(reader) {
  const decoder = new TextDecoder();
  let buffer = '';
  let eventType = null;
  let id = null;
  let data = [];
  const takeEvent = () => {
    const raw = data.join('\n');
    const type = eventType || 'message';
    const eventId = id;
    eventType = null;
    id = null;
    data = [];
    if (!raw) return null;
    try { return { eventType: type, data: JSON.parse(raw), ...(eventId !== null ? { id: eventId } : {}) }; }
    catch { throw new Error('Invalid SSE event data'); }
  };
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';
    for (const rawLine of lines) {
      const line = rawLine.endsWith('\r') ? rawLine.slice(0, -1) : rawLine;
      if (!line) {
        const event = takeEvent();
        if (event) yield event;
        continue;
      }
      if (line.startsWith(':')) continue;
      const separator = line.indexOf(':');
      const field = separator < 0 ? line : line.slice(0, separator);
      let fieldValue = separator < 0 ? '' : line.slice(separator + 1);
      if (fieldValue.startsWith(' ')) fieldValue = fieldValue.slice(1);
      if (field === 'event') eventType = fieldValue;
      if (field === 'id' && !fieldValue.includes('\0')) id = fieldValue;
      if (field === 'data') data.push(fieldValue);
    }
  }
  // An incomplete final record has no committed cursor and is replayed on reconnect.
}
